import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

export interface SectionProps {
  children?: React.ReactNode;
  className?: string;
  content?: string;
  noPaddingX?: boolean;
  textAlignment?: b2x.ResponsiveTextAlign;
  title?: string;
}
export const Section = ({
  children,
  className,
  content,
  noPaddingX,
  textAlignment = 'center',
  title,
}: SectionProps) => {
  const currentBreakpoint = b2x.useBreakpoint();
  return (
    <section className={className}>
      <div className={classnames('container-xxl', { 'px-0': noPaddingX })}>
        {(title || content) && (
          <div className={classnames('mb-4', b2x.buildTextAlignClassNames(textAlignment), { 'px-3': noPaddingX })}>
            {title && (
              <h3
                className={classnames(
                  'mb-3 fw-bold',
                  { h4: b2x.untilBreakpoint('lg', currentBreakpoint) },
                  { h1: !b2x.untilBreakpoint('lg', currentBreakpoint) }
                )}
              >
                {b2x.formatHtml(title)}
              </h3>
            )}
            {content && <div>{b2x.formatHtml(content)}</div>}
          </div>
        )}
        {children && <div className="section-content">{children}</div>}
      </div>
    </section>
  );
};
